export interface AgentSelectionIdentity {
  userId: string;
  orgId: string;
}

interface StoredAgentSelection extends AgentSelectionIdentity {
  sessionId: string | null;
}

export const AGENT_SELECTION_STORAGE_KEY = '@fett/agentCopilotSelection';

export function readAgentSelection(
  storage: Pick<Storage, 'getItem'>,
  identity: AgentSelectionIdentity,
): string | undefined {
  try {
    const raw = storage.getItem(AGENT_SELECTION_STORAGE_KEY);
    if (!raw) return undefined;
    const stored = JSON.parse(raw) as Partial<StoredAgentSelection>;
    if (stored.userId !== identity.userId || stored.orgId !== identity.orgId) return undefined;
    return typeof stored.sessionId === 'string' && stored.sessionId ? stored.sessionId : undefined;
  } catch {
    return undefined;
  }
}

export function writeAgentSelection(
  storage: Pick<Storage, 'setItem'>,
  identity: AgentSelectionIdentity,
  sessionId?: string,
): void {
  try {
    const value: StoredAgentSelection = {
      ...identity,
      sessionId: sessionId || null,
    };
    storage.setItem(AGENT_SELECTION_STORAGE_KEY, JSON.stringify(value));
  } catch {
    // Storage can be unavailable in privacy mode. Keep the in-memory selection usable.
  }
}
